module.exports = __webpack_public_path__ + "static/talking-inside-a-warehouse-aa63e6195c820f8c37862c176705493e.jpg";